export default function genererTypeOt() {
  return {
    tachesTypeOt: [],
    libelle: null,
    actionInterventionOt: null,
    produitId: null,
    societeId: null,
  };
}
